import { ContainerModule } from "inversify";
import { IPodeVisualizarVisaoEstrategicaUseCase } from "../ports/PodeVisualizarVisaoEstrategicaUseCase";
import { PodeVisualizarVisaoEstrategicaUseCaseAdapter } from "../adapters/PodeVisualizarVisaoEstrategicaUseCaseAdapter";
import { IPodeVisualizarVisaoEstrategicaGateway } from "../ports/PodeVisualizarVisaoEstrategicaGateway";
import { PodeVisualizarVisaoEstrategicaGatewayAdapter } from "../adapters/PodeVisualizarVisaoEstrategicaGatewayAdapter";

export const visaoEstrategicaContainer = new ContainerModule((bind) => {
  bind<IPodeVisualizarVisaoEstrategicaUseCase>(
    PodeVisualizarVisaoEstrategicaUseCaseAdapter
  ).toSelf();
  bind<IPodeVisualizarVisaoEstrategicaGateway>(
    PodeVisualizarVisaoEstrategicaGatewayAdapter
  ).toSelf();
});
